module.exports = __webpack_public_path__ + "img/dulaglutide_6.be16369a.jpg";